import type { en } from "./en";

// Thai translations. Missing keys fall back to English via i18next.
export const th: typeof en = {
  common: {
    home: "หน้าแรก",
    no_scores: "ยังไม่มีคะแนน",
    points_count_one: "{{count}} คะแนน",
    points_count_other: "{{count}} คะแนน",
    questions_count_one: "{{count}} ข้อ",
    questions_count_other: "{{count}} ข้อ",
  },
  home: {
    placeholder: "รหัสเกม",
    enter: "เข้าร่วม",
    error_invalid_code: "กรอกรหัสเกม 6 ตัวอักษรที่ได้จากคุณครู",
    footer: "เริ่ม Binogi Buzz ได้จากผลิตภัณฑ์ของ Binogi.com",
    language_label: "ภาษา",
  },
  errors: {
    generic: "เกิดข้อผิดพลาด โปรดลองอีกครั้ง",
    stale_client: "หน้านี้ล้าสมัยแล้ว โปรดรีเฟรช",
    session_not_found: "ไม่พบเซสชันนี้",
    session_not_open: "เซสชันนี้จบแล้ว",
    session_not_active: "คำถามหรือเซสชันนี้จบไปแล้ว",
    not_teacher: "เฉพาะครูเท่านั้นที่ทำได้",
    already_answered: "คุณตอบคำถามนี้ไปแล้ว",
    wrong_question_index: "คำถามนี้ยังไม่เริ่ม",
    name_taken: "ชื่อนี้มีคนใช้แล้ว ลองชื่ออื่น",
    character_busy: "ยังให้ตัวละครกับคุณไม่ได้ในตอนนี้ โปรดลองอีกครั้ง",
  },
  host: {
    input: {
      heading: "เริ่ม Buzz",
      lead:
        "กรอกรหัสบทเรียน Binogi ที่นักเรียนกำลังเรียนอยู่ ระบบจะโหลดคำถามและสร้างเซสชันให้คุณฉายขึ้นกระดาน",
      lesson_code_label: "รหัสบทเรียน",
      placeholder_code: "BIH750",
      load_button: "โหลดบทเรียน",
      try_hint: "ลอง:",
      error_invalid_code: "กรอกรหัสบทเรียน Binogi เช่น BIH750",
      error_not_found: "ไม่พบบทเรียนรหัส {{code}}",
      error_unreachable: "เชื่อมต่อเซิร์ฟเวอร์บทเรียนไม่ได้ ตรวจสอบการเชื่อมต่อแล้วลองอีกครั้ง",
      error_no_questions: "บทเรียน {{code}} ไม่มีคำถามที่ Buzz ใช้ได้",
      error_no_level_questions: "บทเรียน {{code}} ไม่มีคำถามในระดับที่เลือก",
    },
    loading: "กำลังโหลดบทเรียน…",
    placeholder_title: "เริ่ม Binogi Buzz",
    tab_details: "รายละเอียด",
    tab_questions: "คำถาม",
    settings: "การตั้งค่า",
    number_of_students: "จำนวนนักเรียน",
    fewer_students: "นักเรียนน้อยลง",
    more_students: "นักเรียนมากขึ้น",
    player_names: "ชื่อผู้เล่น",
    player_anonymous: "ไม่ระบุชื่อ",
    player_self_chosen: "นักเรียนเลือกเอง",
    language: "ภาษา",
    language_teacher: "ครูเป็นคนเลือก",
    language_students: "นักเรียนเลือกเอง",
    time_per_question: "เวลาต่อคำถาม",
    time_option: "{{seconds}} วิ",
    start_button: "เริ่มเซสชัน",
    start_disabled: "กำหนดจำนวนนักเรียนเพื่อเริ่ม",
    creating: "กำลังสร้างเซสชัน…",
    error_no_questions: "ต้องมีคำถามอย่างน้อยหนึ่งข้อก่อนเริ่ม",
    error_create_failed: "สร้างเซสชันไม่สำเร็จ",
    error_load_failed: "โหลดบทเรียนไม่สำเร็จ",
    no_session: "ไม่มีเซสชันที่กำลังดำเนินอยู่",
    back_to_review: "กลับไปที่คำถาม",
    errors: {
      dismiss: "ปิด",
      refresh: "รีเฟรช",
      attach_failed: "หน้าจอนี้เชื่อมต่อในฐานะครูไม่ได้",
      unreachable: "เชื่อมต่อเซิร์ฟเวอร์ไม่ได้ รีเฟรชหน้าเพื่อลองอีกครั้ง",
      no_token: "แท็บนี้ควบคุมควิซไม่ได้อีกต่อไป เปิด Buzz จากบทเรียนของคุณเพื่อเริ่มเซสชันใหม่",
      taken_over: "ตอนนี้ควิซนี้ถูกควบคุมจากหน้าจออื่น",
      stale_question: "Buzz อัปเดตระหว่างควิซนี้ หน้าจอนี้จึงดำเนินต่อไม่ได้ โหลดหน้าใหม่เพื่อดำเนินควิซต่อจากจุดที่ชั้นเรียนอยู่",
      question_moved_on: "ควิซไปต่อแล้ว หน้าจอนี้จึงตามไม่ทัน โหลดหน้าใหม่เพื่อดำเนินควิซต่อจากจุดที่ชั้นเรียนอยู่",
    },
    entry: {
      opening: "กำลังเปิดมุมมองครู…",
      token_title: "เปิดลิงก์ครูนี้ไม่ได้",
      token_body: "ลิงก์ไม่มีคีย์ของครูหรือหมดอายุแล้ว เปิด Buzz จากบทเรียนของคุณเพื่อสร้างเซสชันใหม่",
      not_found_title: "ไม่พบเซสชัน",
      not_found_body: "เซสชันควิซนี้ไม่มีอยู่แล้ว สร้างเซสชันใหม่เพื่อเล่นต่อ",
      back: "กลับไปหน้าเริ่มต้น",
    },
    questions: {
      drag_aria: "ลากเพื่อจัดลำดับ",
      remove_aria: "ลบคำถาม",
      empty: "ไม่มีคำถามเหลือในเซสชันนี้",
      add: "เพิ่ม",
      add_aria: "เพิ่มคำถาม: {{text}}",
      add_all: "เพิ่มทั้งหมด",
      add_all_n: "เพิ่มคำถามทั้ง {{count}} ข้อ",
      more_one: "มีอีก {{count}} ข้อในบทเรียนนี้",
      more_other: "มีอีก {{count}} ข้อในบทเรียนนี้",
      level_easy: "ง่าย",
      level_medium: "กลาง",
      level_hard: "ยาก",
      multi: "หลายคำตอบ",
    },
    lobby: {
      go_to: "ไปที่ <strong>buzz.binogi.com</strong> แล้วกรอก:",
      or_qr: "…หรือสแกนคิวอาร์โค้ด",
      students_joined_of: "นักเรียนเข้าร่วมแล้ว {{joined}} จาก {{expected}} คน",
      students_joined_one: "นักเรียนเข้าร่วมแล้ว {{count}} คน",
      students_joined_other: "นักเรียนเข้าร่วมแล้ว {{count}} คน",
      waiting: "กำลังรอนักเรียนเข้าร่วม…",
      start_game: "เริ่มเกม",
      connected: "เชื่อมต่อแล้ว",
      connecting: "กำลังเชื่อมต่อ…",
      copy_link: "คัดลอกลิงก์",
      copy_link_copied: "คัดลอกแล้ว!",
    },
    question: {
      header: "คำถามที่ {{index}} จาก {{total}}",
      level: "ระดับ {{level}}",
      none: "ไม่มีคำถามที่กำลังดำเนินอยู่",
      answered: "ตอบแล้ว",
      top_n: "อันดับ {{count}} อันดับแรก",
      answers_heading: "คำตอบ",
      end_question: "จบคำถาม",
      next_question: "คำถามถัดไป",
      see_results: "ดูผลสุดท้าย",
    },
    results: {
      heading: "ผลสุดท้าย",
      all_players: "ผู้เล่นทั้งหมด",
      end_session: "จบเซสชัน",
      new_session: "เซสชันใหม่",
      none: "ไม่มีผู้เล่นในเซสชันนี้",
    },
  },
  join: {
    code_label: "รหัสเกม",
    name_label: "ชื่อของคุณ",
    name_placeholder: "พิมพ์ชื่อของคุณ",
    join_button: "เข้าร่วม",
    joining: "กำลังเข้าร่วม…",
    checking: "กำลังตรวจสอบ…",
    character_hint: "คุณจะได้ชื่อตัวละคร Binogi สนุก ๆ เมื่อเข้าร่วม",
    error_not_found:
      "รหัสนี้ยังไม่มีเซสชันที่เปิดอยู่ ลองตรวจสอบกับคุณครูอีกครั้ง",
    error_lookup_failed: "ค้นหาเซสชันไม่สำเร็จ",
    error_code_required: "กรอกรหัส 6 ตัวอักษร",
    error_name_required: "กรอกชื่อของคุณ",
  },
  play: {
    superseded: "คุณเชื่อมต่ออยู่ในแท็บอื่น — ปิดแท็บนั้นเพื่อเล่นต่อที่นี่",
    back_to_join: "กลับไปหน้าเข้าร่วม",
    no_round: "ไม่มีข้อมูลรอบนี้",
    not_joined: "คุณยังไม่ได้เข้าร่วมเซสชัน",
    no_question: "ไม่มีคำถามที่กำลังดำเนินอยู่",
    keep_awake_hint: "แตะหน้าจอเพื่อไม่ให้หน้าจอดับ",
    waiting: {
      you_are: "คุณคือ",
      get_ready_named: "เตรียมตัวเลย {{name}}!",
      get_ready: "เตรียมพร้อมสำหรับเกมตอบคำถาม!",
      in_room_label: "นักเรียนในห้อง",
      in_room_one: "นักเรียนในห้อง {{count}} คน",
      in_room_other: "นักเรียนในห้อง {{count}} คน",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "ตอบแล้ว!",
      times_up: "หมดเวลา",
      submit: "ส่งคำตอบ",
      submit_n: "ส่งคำตอบ {{count}} ข้อ",
    },
    between: {
      correct: "ถูกต้อง!",
      wrong: "เกือบแล้ว!",
      times_up: "หมดเวลา",
      points_gained: "+{{count}} คะแนน",
      your_score: "คะแนนของคุณ",
      your_rank: "อันดับที่ {{rank}}",
      top_n: "อันดับ {{count}} อันดับแรก",
      waiting_next: "กำลังรอคำถามถัดไป…",
    },
    finished: {
      heading: "ขอบคุณที่ร่วมเล่น Binogi Buzz!",
      your_final_rank: "อันดับสุดท้ายของคุณ",
      top_n: "อันดับ {{count}} อันดับแรก",
      none: "ไม่มีผลที่จะแสดง",
    },
  },
  characters: {
    heading: "ตัวละคร Binogi",
    lead: "นักเรียน {{count}} คนจะได้รับตัวละครเมื่อเข้าร่วม ตามลำดับนี้",
  },
};
